import CompetencyCourse from "@/components/training/CompetencyCourse";
import { responsibleAIPracticeCourse } from "@/data/longhandCompetencyCourses";

const ResponsibleAIPractice = () => <CompetencyCourse course={responsibleAIPracticeCourse} />;

export default ResponsibleAIPractice;
